import { render, staticRenderFns } from "./annotationsControl.vue.js?vue&type=template&id=4eac2162!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./annotationsControl.vue?vue&type=template&id=4eac2162"
import script from "./annotationsControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./annotationsControl.vue?vue&type=script&lang=js"
export * from "./annotationsControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./annotationsControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports